import createIcon from "../createIcon";
export var SunConfig = {
  displayName: "Sun",
  attrs: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  },
  css: {
    display: "inline-block",
    verticalAlign: "middle",
    overflow: "hidden",
    maxHeight: "100%",
    maxWidth: "100%",
    margin: "auto"
  },
  width: 24,
  height: 24,
  titleKey: "Sun-title",
  viewBox: "0 0 24 24",
  labelledby: "icon-title-Sun",
  body: [{
    type: "circle",
    props: {
      cx: 12,
      cy: 12,
      r: 5,
      key: "k0"
    }
  }, {
    type: "line",
    props: {
      x1: 12,
      x2: 12,
      y1: 1,
      y2: 3,
      key: "k1"
    }
  }, {
    type: "line",
    props: {
      x1: 12,
      x2: 12,
      y1: 21,
      y2: 23,
      key: "k2"
    }
  }, {
    type: "line",
    props: {
      x1: 4.22,
      x2: 5.64,
      y1: 4.22,
      y2: 5.64,
      key: "k3"
    }
  }, {
    type: "line",
    props: {
      x1: 18.36,
      x2: 19.78,
      y1: 18.36,
      y2: 19.78,
      key: "k4"
    }
  }, {
    type: "line",
    props: {
      x1: 1,
      x2: 3,
      y1: 12,
      y2: 12,
      key: "k5"
    }
  }, {
    type: "line",
    props: {
      x1: 21,
      x2: 23,
      y1: 12,
      y2: 12,
      key: "k6"
    }
  }, {
    type: "line",
    props: {
      x1: 4.22,
      x2: 5.64,
      y1: 19.78,
      y2: 18.36,
      key: "k7"
    }
  }, {
    type: "line",
    props: {
      x1: 18.36,
      x2: 19.78,
      y1: 5.64,
      y2: 4.22,
      key: "k8"
    }
  }]
};
export default createIcon(SunConfig);